export enum TSGeschwisterbonusTyp {
    LUZERN = 'LUZERN',
    SCHWYZ = 'SCHWYZ',
    SCHWYZ_2 = 'SCHWYZ_2',
    NONE = 'NONE'
}
